import Api from "./index";

export const GiftCardCategoryApi = () => Api.POST({ url: "/v1/GameCategory" });


export interface IGiftCardSubCategory {
  group_id: number;
}

export const GiftCardSubCategoryApi = (data: IGiftCardSubCategory) =>
  Api.POST({ url: "v1/SubGameCategory", data });

export interface IGiftCardSingleProduct {
  group_id: number;
  productCode: number;
}

export const GiftCardSingleProductApi = (data: IGiftCardSingleProduct) =>
  Api.POST({ url: "v1/GameProduct", data });

export interface IGiftCardSmartIpg {
  additional_data: string;
  productCode: number;
  quantity: number;
  amount: number;
  productName: string;
  base_url: string;
}

export const GiftCardSmartIpgApi = (data: any) =>
  Api.POST({ url: "v1/Smart_ipg_larbey", data });



// export const InternetBuyApi = (data: IInternetBuy) =>
//   Api.POST({ url: "/v1/internet_buy", data });

// export interface IInternetWalletBuy {
//   user_pan: string;
//   second_password: string;
//   cvv2: number;
//   expire_year: number;
//   expire_month: number;
//   additional_data?: string;
//   package_id: number;
//   package_title: string;
//   amount: number;
//   mobile_number: string;
//   operator_type_id: number;
//   simcard_type_id?: number;
//   package_type_id: number;
//   package_type_title: string;
// }

// export const InternetWalletBuyApi = (data: IInternetWalletBuy) =>
//   Api.POST({ url: "/v1/buy_internet_package", data, hasErr: false });
